import { APP_ENVIRONMENT, BASE_ENROLLMENTS_URL } from "./index";
import { LOG_LEVELS, SendLog } from "./log";
import { RestClient } from "./rest-client";
import { MixpanelService } from "./tracker/mixpanel.service";
import { EnrollmentStatusEntity } from "./types/enrollments.entity";
import { ErrorResponse } from "./types/common.entity";
import { handlingEnrollmentErrors } from "./handling-enrollment-errors-helpers";
import axios from "axios";
import { GA_EVENTS } from "./tracker/ga.types";

export const postEnrollmentAuthorizationServices = async ({
  userId,
  captchaToken,
}: {
  userId: string;
  captchaToken: string;
}) => {
  try {
    const url = BASE_ENROLLMENTS_URL + `enrollments/authorization`;

    MixpanelService.track(
      "Start post enrollments autorization service",
      {
        userId: userId,
      },
      true
    );

    const res = await RestClient.request<EnrollmentStatusEntity>({
      method: "post",
      url,
      data: {
        userId,
      },
      excludeHeaders: ["obTraceId"],
      additionalHeaders: {
        "Recaptcha-Answer": captchaToken,
        clientId: APP_ENVIRONMENT,
      },
      ignoreErrors: true,
    });

    if (res.status === 200) {
      const { enrollmentId } = res.data;

      if (!enrollmentId) {
        console.error("Enrollments authorization creation request: try");

        MixpanelService.track("Errored", {
          When: "Enrollments  authorization creation request: try",
        });

        return {
          isSuccess: false,
          data: res.data as EnrollmentStatusEntity,
          status: res.status,
        };
      }
      return {
        isSuccess: true,
        data: res.data as EnrollmentStatusEntity,
        status: res.status,
      };
    }

    console.error("Enrollments authorization creation request: try");

    MixpanelService.track("Errored", {
      When: "Enrollments  authorization creation request: try",
    });

    await handlingEnrollmentErrors({
      status: res.status,
      url: `in the post /api/v1/enrollments/authorization`,
      eventName:
        GA_EVENTS.ERRORS.REQUEST_ENROLLMENT_REQUEST_CREATE_ONBOARDING_LANDING,
    });

    return {
      isSuccess: false,
      data: res.data as EnrollmentStatusEntity,
      status: res.status,
    };
  } catch (error: unknown) {

    MixpanelService.track("Error Catch: Enrollments authorization creation request", {
      Errors: error,
    });

    console.error("Error Catch: Enrollments authorization creation request", error
    );

    if (axios.isAxiosError(error)) {
      const statusCode = error.response?.status;
      const response = error.response;
      const errorMessage = error.message;

      console.error("Error in Enrollments authorization creation request", errorMessage);

      await handlingEnrollmentErrors({
        status: response.status,
        url: `in the  post /api/v1/enrollments/authorization`,
        eventName:
          GA_EVENTS.ERRORS.REQUEST_ENROLLMENT_REQUEST_CREATE_ONBOARDING_LANDING,
      });

      return {
        isSuccess: false,
        data: response.data as ErrorResponse,
        status: statusCode || 500,
      };
    } else {
      console.error("Unknown error occurred", error);
      await SendLog(
        LOG_LEVELS.ERROR,
        GA_EVENTS.ERRORS.REQUEST_ENROLLMENT_REQUEST_CREATE_ONBOARDING_LANDING,
        `Unknown error in the  post /api/v1/enrollments/authorization`
      );
      return {
        isSuccess: false,
        data: {} as ErrorResponse,
        status: 500,
      };
    }
  }
};
